import { render, staticRenderFns } from "./Reset-Password.vue?vue&type=template&id=1f3f0c03&scoped=true&"
import script from "./Reset-Password.vue?vue&type=script&lang=js&"
export * from "./Reset-Password.vue?vue&type=script&lang=js&"
import style0 from "./Reset-Password.vue?vue&type=style&index=0&id=1f3f0c03&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3f0c03",
  null
  
)

export default component.exports